export default "__VITE_ASSET__BlR3fKPJ__"